import ordersApi from "@api/orders";
import { useQuery } from "@tanstack/react-query";

export const useGetOrders = (pageNumber = 0, options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: ['orders', pageNumber],
        queryFn: async () => await ordersApi.getOrders(pageNumber),
        enabled: options?.enabled !== false,
    });
};
